import { render, staticRenderFns } from "./SeminarConfig.vue?vue&type=template&id=d43f95ea"
import script from "./SeminarConfig.vue?vue&type=script&lang=js"
export * from "./SeminarConfig.vue?vue&type=script&lang=js"
import style0 from "./SeminarConfig.vue?vue&type=style&index=0&id=d43f95ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports